module.exports = __webpack_public_path__ + "static/media/chorthippus_biguttulus.ecccab7b.mp3";